document.cookie = `started=${Date.now()}; expires=${tomorrow()}`;

window.setCookie = (name) => {
    document.cookie = `${name}=${Date.now()}; expires=${tomorrow()}`;
};

function tomorrow() {
    return new Date(Date.now() + 24 * 3600 * 1000);
}
